// Angular DOM
import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild
} from "@angular/core";
// Third Party Services
import { ActivatedRoute, NavigationExtras, Router } from "@angular/router";
import {
  NgbModal,
  NgbModalOptions,
  NgbDatepickerConfig
} from "@ng-bootstrap/ng-bootstrap";
// Redux Store
import { Store } from "@ngrx/store";
import { SetPatientAction } from "../../actions";
// Models
import { Patient } from "../../models";
// Services
import { AuthService, PatientService, UtilService } from "../../services";
import { Subscription } from "rxjs/Subscription";

@Component({
  selector: "app-patient-details-modal",
  templateUrl: "./patient-details-modal.component.html",
  styleUrls: ["./patient-details-modal.component.scss"]
})
export class PatientDetailsNewModalComponent
  implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild("content") template: TemplateRef<any>;

  public redirect: string;

  // public years: Array<number> = [];
  public modalRef: any;
  public patient: any;
  public confirm: boolean = false;
  public editMode: boolean = false;
  public modalTitle = "Create a New Patient";
  public showPatientExistsError = false;
  public isOfficeStaff: boolean;
  public dateOfBirth: { year: number; month: number; day: number };

  private subscriptions: { [name: string]: Subscription } = {};
  private modalOptions: NgbModalOptions = {
    backdrop: "static",
    windowClass: "patient-details",
    container: "app-patient-details-modal",
    keyboard: false
  };

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    private modalService: NgbModal,
    private utilService: UtilService,
    private store: Store<any>,
    private patientService: PatientService,
    private authService: AuthService,
    public config: NgbDatepickerConfig
  ) {
    // customize default values of datepickers used by this component tree
    config.minDate = { year: 1900, month: 1, day: 1 };
    config.maxDate = { year: new Date().getFullYear() - 1, month: 12, day: 31 };
    // days that don't belong to current month are not visible
    config.outsideDays = "hidden";
  }

  ngOnInit() {
    this.subscriptions["redirect"] = this.route.queryParams.subscribe(
      params => {
        this.redirect = params["redirect"] || "";
      }
    );

    this.subscriptions["patient"] = this.store
      .select("patient")
      .subscribe(patient => {
        this.patient = Object.assign({}, new Patient(), patient);
      });

    this.isOfficeStaff = this.authService.getUser().Role === "staff";
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.modalRef = this.modalService.open(this.template, this.modalOptions);
    });
  }

  ngOnDestroy() {
    setTimeout(() => {
      this.modalRef.close();
    });

    for (let el in this.subscriptions) {
      if (el) {
        this.subscriptions[el].unsubscribe();
      }
    }
  }

  cancel() {
    this.store.dispatch({ type: "CLEAR_PATIENT" });
    this.store.dispatch({ type: "CLEAR_TEST_ORDER" });
    this.router.navigate(["/patients"]);
  }

  update() {
    this.patient = {
      ...this.patient,
      BirthDay: String(this.dateOfBirth.day),
      BirthMonth: String(this.dateOfBirth.month),
      BirthYear: String(this.dateOfBirth.year)
    };

    this.store.dispatch(new SetPatientAction(this.patient, this.utilService));
    let navigationExtras: NavigationExtras = {
      queryParams: { redirect: this.redirect }
    };
    this.router.navigate(
      ["/patients/create/additional-details"],
      navigationExtras
    );
  }

  isString(val) {
    return typeof val === "string";
  }

  checkFormValidity(form) {
    let detectNonAlphaRegex = /[^a-zA-Z]/g;
    return form.invalid || detectNonAlphaRegex.test(this.patient.MiddleName);
  }
}



// WEBPACK FOOTER //
// /Users/maxsheikhizadeh/Desktop/GEN/physician-portal/src/app/shared/components/patient-details-modal/patient-details-new-modal.component.ts